import WordIcon from "./WordIcon";
export default WordIcon;